export const en = {
  rsvpPage: {
    feedback: {
      banner: {
        thanks: 'Thanks for attending this opportunity!',
        cta: 'Give your feedback',
        description: 'so that we can make volunteering even better',
      },
    },
    navigation: {
      details: 'Details',
      volunteers: 'Volunteers',
      feedback: 'Feedback',
      photos: 'Photos',
    },
    hero: {
      imageAlt: '{{name}} banner image',
      cancelled: 'Cancelled',
    },
    dateTime: {
      to: 'to',
      labels: {
        sameDay: '{{date}} at {{time}}',
        multiDay: '{{startDate}} to {{endDate}}',
        time: '{{startTime}} to {{endTime}}',
      },
    },
    detailsTab: {
      completion: {
        title: 'Opportunity Complete!',
        opportunity_complete: '+1 Opportunity complete',
        volunteer_hours: '+{{hours}} Volunteer hours',
      },
      nonprofit: {
        title: 'About the Nonprofit',
        website_button: 'Visit website',
        logo_alt: '{{name}} logo',
      },
      contact: {
        email: 'events@purposely.co',
      },
      photos: {
        title: 'Photos from Past Events',
      },
    },
    feedbackPreview: {
      photos: {
        view_all: 'View all photos',
        upload_button: 'Upload Photos',
        empty_state: {
          message: 'There are no photos yet for this opportunity.',
          upload_prompt:
            "If you snapped some, upload them so your company can see your team's impact!",
        },
        validation_error: 'Please upload at least one photo',
        success_message: 'Thank you for sharing your photos!',
      },
    },
    feedbackTab: {
      header: {
        title: 'Feedback Summary',
        responses_collected: '{{responses}}/{{total}} Responses Collected',
      },
      sections: {
        attendance: {
          title: 'Did you go?',
          responses: '{{count}} Response',
          responses_other: '{{count}} Responses',
          legend: {
            yes: 'Yes',
            no: 'No',
          },
        },
        satisfaction: {
          title: 'How did you like the opportunity?',
          legend: {
            loved: 'Loved',
            liked: 'Liked',
            disliked: 'Disliked',
          },
        },
        feedback: {
          positive_title: 'What did you like about the event?',
          improvement_title: 'Is there anything that could be improved?',
          no_attend_title: 'Reason for not attending',
          empty_state: '--',
        },
      },
    },
    photosTab: {
      header: {
        title: 'Photos',
        description:
          "Didn't attend the event? That's okay! You can still upload photos from the event to share with others.",
      },
      form: {
        photos_hint: 'Drag and drop your photos here or click to browse',
        submit_button: 'Submit',
      },
    },
    joinBlock: {
      status: {
        volunteering: "You're Volunteering!",
        closed: 'Sign Up Closed',
        full: 'Opportunity Full',
        pending: 'Pending Approval',
        sign_in: 'Sign in to join',
        waitlisted_one: 'On Waitlist (#{{count}})',
        waitlisted_other: 'On Waitlist (#{{count}})',
        waitlisted_label: 'On Waitlist',
        waitlist_hint: "You'll be notified when a spot opens up",
        waitlist_next: "You're next in line — you'll be first to get a spot.",
        waitlist_ahead_one: '{{count}} person ahead of you in the queue.',
        waitlist_ahead_other: '{{count}} people ahead of you in the queue.',
      },
      buttons: {
        join: 'Join Event',
        leave: 'Leave Event',
        volunteering: "You're Volunteering",
        add_hours: 'Add Hours',
        edit_hours: 'Edit Hours',
        join_waitlist: 'Join Waitlist',
        leave_waitlist: 'Leave Waitlist',
      },
      form: {
        title: 'Save your spot',
        fields: {
          full_name: {
            label: 'Full Name',
            placeholder: 'Full Name',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
          },
        },
        submit: 'Join',
      },
      alerts: {
        joined: "You've joined the event!",
        left: "You've left the event",
      },
      login_prompt: {
        more_opportunities: 'to view more opportunities at your company',
        save_history: 'first to save your volunteering history',
      },
      shifts: {
        title: 'Shift Selection',
        choose: 'Choose your shifts',
        select_all: 'Select all that apply',
        status: {
          open: 'Open',
          full: 'Full',
          closed: 'Closed',
          joined: "✓ You're in",
          adding: '+ Adding',
          removing: '− Removing',
          spots_left_one: '{{count}} spot left',
          spots_left_other: '{{count}} spots left',
          filled: '{{filled}} of {{total}} spots filled',
          waitlisted: 'Waitlist #{{position}}',
          join_waitlist: 'Join Waitlist',
          joining_waitlist: 'Joining Waitlist',
          waitlist_tap_hint: 'Tap to join the waitlist',
          waitlist_leave_tap_hint: 'Tap to leave the waitlist',
          queued: 'Queued',
          waitlist_next: "You're next in line for this shift.",
          waitlist_ahead_one: '{{count}} ahead of you.',
          waitlist_ahead_other: '{{count}} ahead of you.',
        },
        confirmation: {
          removed_all: "You'll be removed from all shifts",
          removed_one: "Removed from 1 shift",
          removed_other: "Removed from {{count}} shifts",
          signed_up_one: "You'll be signed up for {{count}} shift",
          signed_up_other: "You'll be signed up for {{count}} shifts",
          updating: 'Updating...',
          confirm: 'Confirm Changes',
          volunteering_count_one: 'Signed up for {{count}} shift',
          volunteering_count_other: 'Signed up for {{count}} shifts',
          volunteering: "You're Volunteering ✓",
          join: 'Join Shifts',
          hint_change: 'You can change or cancel anytime',
          hint_tap: 'Tap any shift above to add or remove',
          join_waitlist_one: 'Join Waitlist for {{count}} Shift',
          join_waitlist_other: 'Join Waitlist for {{count}} Shifts',
          join_waitlist_loading: 'Joining Waitlist...',
          waitlist_pending_one: "You'll be #{{position}} on the waitlist for {{count}} shift",
          waitlist_pending_other: "You'll join the waitlist for {{count}} shifts",
        },
      },
    },
    leaveModal: {
      title: 'Are you sure you want to leave?',
      message:
        'The nonprofit has your attendance in mind, are you sure you want to leave this opportunity?',
      message_waitlist:
        'There is a waitlist for this event. If you leave, you will need to join the waitlist to attend again.',
      buttons: {
        confirm: 'Leave Event',
        cancel: 'Cancel',
      },
    },
    leaveShiftModal: {
      title_one: 'Are you sure you want to leave this shift?',
      title_other: 'Are you sure you want to leave these {{count}} shifts?',
      message_one:
        'The nonprofit has your attendance in mind, are you sure you want to remove this shift?',
      message_other:
        'The nonprofit has your attendance in mind, are you sure you want to remove these shifts?',
      buttons: {
        confirm_one: 'Remove shift',
        confirm_other: 'Remove shifts',
        cancel: 'Cancel',
      },
    },
    locationBlock: {
      virtual_event: 'Virtual Event',
      self_directed: 'Anywhere',
      event_link: 'Event Link',
      event_link_later: 'Event link to be provided later',
    },
    loginPrompt: {
      login: 'Log in',
      signup: 'sign up',
      or: 'or',
    },
    loginToCancelModal: {
      title: 'Active account',
      message: 'We see you have an account with us! Please',
      login_link: 'login',
      action: 'to cancel.',
    },
    memberModal: {
      title: 'Volunteers',
      empty_state: 'No volunteers yet. Be the first to join!',
      see_whos_going: "to see who's going!",
    },
    leaveWaitlistModal: {
      title: 'Leave Waitlist',
      message: "Are you sure? If you leave, you'll need to rejoin from the back of the waitlist.",
      buttons: {
        confirm: 'Leave Waitlist',
        cancel: 'Cancel',
      },
    },
    waitlistModal: {
      title: 'Join the Waitlist',
      description: "You'll be notified by email when a spot opens up and you're added to the event.",
      ahead_count_zero: 'There is no one ahead of you on the waitlist.',
      ahead_count: 'There are currently <bold>{{count}} people</bold> ahead of you on the waitlist.',
      buttons: {
        confirm: 'Join Waitlist',
        cancel: 'Cancel',
      },
    },
    teamModal:{
      title: "Request to join team event",
      top_text: "This event is limited to a specific team and requires approval from the event organizer. We’ll email you once your request has been reviewed.",
      bottom_text: 'You can check the status anytime in My Volunteering.',
    },
    addVolunteersModal: {
      form: {
        label: 'Add Volunteer',
        hint: "Can't find a user? Type an email and press enter to add it",
        submit_button: 'Submit',
      },
      success_message: 'Volunteers added',
    },
    inviteVolunteersModal: {
      form: {
        label: 'Invite Volunteer',
        hint: "Can't find a user? Type an email and press enter to add it",
        submit_button: 'Submit',
      },
      success_message: 'Invite emails sent',
    },
    shareBlock: {
      title: 'Share',
      buttons: {
        copy_invite: 'Copy Invite',
        add_calendar: 'Add to Calendar',
      },
      calendar_options: {
        google: 'Google Calendar',
        apple: 'Apple Calendar',
        outlook: 'Outlook Calendar',
      },
      invite_template: {
        header:
          'New Volunteer Opportunity: Join us for {{name}} with {{nonprofitName}}!',
        when: 'When: {{datetime}} {{timezone}}',
        where: 'Where: {{location}}',
        virtual: {
          with_link: 'Virtual ({{link}})',
          no_link: 'Virtual (Event link to be provided later)',
        },
        signup: 'Sign up below',
        join_others:
          ' and join {{names}}{{overflow}} for some volunteering fun:',
        join_count: ' and join {{count}} others for some volunteering fun:',
        overflow_text: {
          single: ' and {{count}} other co-worker',
          multiple: ' and {{count}} others',
        },
      },
      alerts: {
        copied: 'Invite message copied to your clipboard',
      },
    },
    volunteersBlock: {
      count: {
        volunteers: '{{current}}/{{capacity}} Volunteers',
      },
    },
    volunteersTab: {
      table: {
        title: 'Volunteers',
        subtext:
          'Manage attendees and view their feedback once the event is finished',
        columns: {
          name: 'Name',
          joined: 'Joined',
          feedback_status: 'Feedback Status',
          rating: 'Rating',
          attended: 'Attended',
          volunteer_hours: 'Volunteer Hours',
          status: 'Status',
          waitlist_position: 'Waitlist #',
        },
      },
      actions: {
        hide_invite: 'Hide invite',
        remove_volunteer: 'Remove Volunteer',
        make_organizer: 'Make organizer',
        remove_organizer: 'Remove as organizer',
        add_volunteers: 'Add Volunteers',
        edit_hours: 'Edit Volunteer Hours',
        invite_volunteers: 'Invite Volunteers',
        save: 'Save',
        cancel: 'Cancel',
      },
      organizers: {
        title: 'Organizers',
        tooltip: "Organizers help run the event. They can approve or deny people waiting to join, add and invite volunteers, and get the same join and waitlist emails as the creator. They can't edit or cancel the event. Organizers must be attending — if they leave the event, they stop being an organizer.",
        hint: 'To add an organizer, open the menu on an attending volunteer and choose “Make organizer”.',
        role_creator: 'Creator',
        role_requester: 'Requester',
        role_organizer: 'Organizer',
        added: '{{name}} is now an organizer',
        removed: '{{name}} is no longer an organizer',
      },
      alerts: {
        email_copied: '{{email}} copied to your clipboard',
        hours_updated: 'Volunteer hours updated',
        invite_copied: 'Invite message copied to your clipboard',
      },
      empty_state: {
        title: 'No volunteers yet',
        description:
          'Invite someone to join this event and make an impact together!',
        copy_invite: 'Copy Invite Message',
      },
      attendance: {
        yes: 'Yes',
        no: 'No',
        pending: '—',
      },
      invite_template: {
        title:
          'New Volunteer Opportunity: Join us for {{name}} with {{nonprofitName}}!',
        when: 'When: {{datetime}}',
        where: 'Where: {{location}}',
        virtual: {
          with_link: 'Virtual ({{link}})',
          no_link: 'Virtual (Event link to be provided later)',
        },
        signup: 'Sign up below:',
      },
      headerActions: {
        save: 'Save',
        cancel: 'Cancel',
        add_volunteers: 'Add Volunteers',
        edit_hours: 'Edit Volunteer Hours',
        invite_volunteers: 'Invite Volunteers',
      },
      emptyState: {
        title: 'No volunteers yet',
        description:
          'Invite someone to join this event and make an impact together!',
        copy_invite: 'Copy Invite Message',
      },
      labels: {
        invited: '(invited)',
        waitlisted: '(waitlisted)',
        virtual: 'Virtual',
        virtual_link_later: 'Virtual (Event link to be provided later)',
      },
      filters: {
        label: 'Type',
        all: 'All',
        attending: 'Attending',
        waitlisted: 'Waitlisted',
      },
    },
    confirmRemoveOrganizerModal: {
      title: 'Remove Organizer',
      message:
        "Remove {{name}} as an organizer? They'll stay signed up as a volunteer but won't be able to approve people or manage volunteers anymore.",
      message_self:
        "Remove yourself as an organizer? You'll stay signed up as a volunteer but won't be able to approve people or manage volunteers anymore.",
      buttons: {
        confirm: 'Remove',
        cancel: 'Cancel',
      },
    },
    confirmRemoveVolunteerModal: {
      title: 'Remove Volunteer',
      message:
        'Are you sure you want to remove {{name}} as a volunteer in this opportunity?',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    confirmHideInviteModal: {
      title: 'Hide Invite',
      message:
        'Are you sure you want to hide the invite sent to <0>{{email}}</0>? An invite has been sent by email that cannot be retracted.',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    eventCard: {
      tags: {
        communityAction: 'Community Action',
        singleEvent: 'Single Event',
      },
      spots: {
        completed: 'Completed',
        waitlistOpen: 'Waitlist open',
        eventFull: 'Event full',
        almostFull_one: 'Almost full · {{count}} spot left',
        almostFull_other: 'Almost full · {{count}} spots left',
        fillingUp_one: 'Filling up · {{count}} spot left',
        fillingUp_other: 'Filling up · {{count}} spots left',
        open_one: 'Open · {{count}} spot left',
        open_other: 'Open · {{count}} spots left',
      },
      location: {
        virtual: 'Virtual',
        selfDirected: 'Anywhere',
      },
      volunteers: '{{count}}/{{total}} volunteers',
    },
    nonprofitProfile: {
      stats: {
        events: 'Events',
        volunteers: 'Volunteers',
        hoursVolunteered: 'Hours Volunteered',
        companyImpactTitle: "Your Company's Impact",
      },
      sections: {
        about: 'About',
        gallery: 'Photos',
        upcomingEvents: 'Upcoming Events',
        pastEvents: 'Past Events',
        noUpcomingEvents: 'No upcoming events',
        noPastEvents: 'No past events',
        orgInfo: 'Organization Info',
        location: 'Location',
        website: 'Website',
      },
    },
  },
  feedbackModal: {
    attendance: {
      title: 'Did you attend?',
      description: 'Now that the event is over, let us know if you were able to attend',
      buttons: {
        yes: 'Yes',
        no: 'No',
      },
    },
    noAttendReason: {
      title: 'Thanks for letting us know!',
      description: "If you're comfortable sharing, let us know why you couldn't make it",
      placeholder: 'Tell us why you couldn\'t attend...',
      buttons: {
        skip: 'No Thanks',
        submit: 'Submit',
      },
    },
    main: {
      title: 'How did it go?',
      description: 'Give your feedback about how this opportunity went',
      fields: {
        satisfaction: {
          label: 'How did you like the opportunity?',
        },
        positive_feedback: {
          label: 'What did you like about the event?',
          placeholder: 'Let us know what made the event great for you!',
        },
        improvement_suggestions: {
          label: 'Is there anything that could be improved?',
          placeholder: 'What did you not like?',
        },
        photos: {
          upload_message: 'Drag and drop your photos here or click to browse',
          greenshield_disclaimer:
            'Please note that photographs captured during Purposely events may be used for internal and external communications purposes. This may include use on our intranet, newsletters, reports, presentations, social media channels, and other corporate materials.',
        },
      },
      buttons: {
        submit: 'Submit',
      },
      validations: {
        satisfaction_required: 'Required.',
        positive_feedback_required: 'Required.',
        improvement_required: 'Required.',
      },
      alerts: {
        success: 'Thanks for your feedback!',
      },
    },
  },
}
